module.exports = {"130902001":"建设北街街道","130902002":"车站街道","130902003":"南大街街道","130902004":"东环街道","130902005":"道东街道","130902200":"小赵庄乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130902.json
// module id = 190
// module chunks = 0